<template>
<div class="register">
<!-- iphone and ipad -->
<el-row v-if="WidthSize < 1000">
  <el-col :span="22" :offset="1"><div class="from">
  <!-- 标题 -->
  <span>绑定账号</span>
  <!-- 表单 -->
  <el-row>
    <el-col :span="20" >
  <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
    <!-- 名字 -->
    <el-form-item label="账号" prop="username">
      <el-input v-model="ruleForm.username" placeholder="请输入账号"></el-input>
    </el-form-item>
    <!-- 手机号 -->
    <el-form-item label="手机号" prop="mobile">
      <el-input v-model="ruleForm.mobile"  name="mobile" placeholder="请输入手机号" @blur="handch"></el-input>
    </el-form-item>
    <!-- <span style="font-size: 14px;color: red;text-align: left;" v-show="count">手机号已经被注册过</span> -->
    <div class="block" style="width: 90%;margin: 0px auto;position: relative;height: 40px;" v-show="yanShow">
      <!-- <span style="display: inline-block; position: absolute;left: -250px;font-size: 16px;top: -10px;">验证</span> -->
        <el-slider v-model="ruleForm.num" style="width: 80%;position: absolute;left: 50px;height: 20px;"></el-slider>
      </div>
    <!-- 验证码 -->
    <!-- ipad and Maxiphone -->
    <el-form-item label="验证码" prop="sms_code" v-show="WidthSize > 375">
        <el-input v-model="ruleForm.sms_code" style="float: left;display: inline-block;width: 50%;" placeholder="请输入验证码"></el-input><el-button @click.prevent="Verifi" style="float: left;width: 50%; text-align: left;" type="primary" :disabled="disabled">{{btnTitle}}</el-button>
      </el-form-item>
      <!-- miniphone -->
      <el-form-item label="验证码" prop="sms_code" v-show="WidthSize <= 374">
          <el-input v-model="ruleForm.sms_code" style="float: left;display: inline-block;width: 50%;" placeholder="请输入验证码"></el-input><el-button @click.prevent="Verifi" style="float: left;width: 50%; text-align: left;" type="primary" :disabled="disabled">{{btnTitle}}</el-button>
        </el-form-item>
    <!-- 密码 -->
    <el-form-item label="密码" prop="password">
        <el-input type="password" v-model="ruleForm.password" autocomplete="off" placeholder="至少8-16个字符，至少1个大写字母，1个小写字母和1个数字" @blur="passwordFu(ruleForm.password)"></el-input>
      </el-form-item>
    <!-- 再次密码 -->
      <el-form-item label="确认密码" prop="password2">
        <el-input type="password" v-model="ruleForm.password2" autocomplete="off" placeholder="请再次确认密码" @blur="passwordFu2(ruleForm.password2)"></el-input>
      </el-form-item>
    <!--  -->
    <el-form-item label="" prop="allow">
       <el-checkbox-group v-model="ruleForm.allow">
          <el-checkbox label="我已阅读并同意《服务协议》" nam="allow"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
     <!-- 提交 -->
    <el-form-item>
      <el-button type="success" @click="submitForm('ruleForm')">注册</el-button>
      <el-button @click="resetForm('ruleForm')">重置注册</el-button>
    </el-form-item>
  </el-form>
  </el-col>
  </el-row>
  </div>
</el-col>
</el-row>

<!-- pc -->
<el-row v-else-if="WidthSize >= 1000">
  <el-col :span="10" :offset="7"><div class="from">
  <!-- 标题 -->
  <span>绑定账号</span>
  <!-- 表单 -->
  <el-row>
    <el-col :span="20" >
  <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
    <!-- 名字 -->
    <el-form-item label="账号" prop="username">
      <el-input v-model="ruleForm.username" placeholder="请输入账号"></el-input>
    </el-form-item>
    <!-- 手机号 -->
    <el-form-item label="手机号" prop="mobile">
      <el-input v-model="ruleForm.mobile"  name="mobile" placeholder="请输入手机号" @blur="handch"></el-input>
    </el-form-item>
    <!-- <span style="font-size: 14px;color: red;text-align: left;" v-show="count">手机号已经被注册过</span> -->
    <div class="block" style="width: 90%;margin: 0px auto;position: relative;height: 40px;" v-show="yanShow">
      <!-- <span style="display: inline-block; position: absolute;left: -250px;font-size: 16px;top: -10px;">验证</span> -->
        <el-slider v-model="ruleForm.num" style="width: 80%;position: absolute;left: 50px;height: 20px;"></el-slider>
      </div>
    <!-- 验证码 -->

    <el-form-item label="验证码" prop="sms_code">
        <el-input v-model="ruleForm.sms_code" style="float: left;display: inline-block;width: 50%;" placeholder="请输入验证码"></el-input><el-button @click.prevent="Verifi" style="float: left;width: 40%;margin-left: 20px;" type="primary" :disabled="disabled">{{btnTitle}}</el-button>
      </el-form-item>
    <!-- 密码 -->
    <el-form-item label="密码" prop="password">
        <el-input type="password" v-model="ruleForm.password" autocomplete="off" placeholder="至少8-16个字符，至少1个大写字母，1个小写字母和1个数字" @blur="passwordFu(ruleForm.password)"></el-input>
      </el-form-item>
    <!-- 再次密码 -->
      <el-form-item label="确认密码" prop="password2">
        <el-input type="password" v-model="ruleForm.password2" autocomplete="off" placeholder="请再次确认密码" @blur="passwordFu2(ruleForm.password2)"></el-input>
      </el-form-item>
    <!--  -->
    <el-form-item label="" prop="allow">
       <el-checkbox-group v-model="ruleForm.allow">
          <el-checkbox label="我已阅读并同意《服务协议》" nam="allow"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
     <!-- 提交 -->
    <el-form-item>
      <el-button type="success" @click="submitForm('ruleForm')">注册</el-button>
      <el-button @click="resetForm('ruleForm')">重置注册</el-button>
    </el-form-item>
  </el-form>
  </el-col>
  </el-row>
  </div>
</el-col>
</el-row>



</div>
</template>

<script>
// import [ vuex ] from 'VUEX'
  export default {
    data() {
      var checkAge = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手机号没有填写'));
        } else {
          if(value != '') {
            var reg=/^1[3456789]\d{9}$/;
            if(!reg.test(value)){
                callback(new Error('请输入有效的手机号码'));
            }
          }
          callback ()
        }
      };
      var Verification = (rule, value, callback) => {

        if (value === '') {
          callback(new Error('验证码不能为空'));
        } else {
          callback();
        }
      };
      var userName = (rule, value, callback) => {
if (!value) {
          return callback(new Error('昵称没有填写'));
        } else {
          if(value != '') {
            var reg=/^[0-9]{5,20}$/;
            if(!reg.test(value)){
                callback(new Error('请输入5-20位数字'));
            }
          }
          callback ()
        }
      };
      return {
        WidthSize:1010,//适配
        WidthSize2:'',
        verifyCode:"", //验证码
        btnTitle:"获取验证码",//按钮
        disabled:false,  //是否可点击
        show:false,//拉条验证
        yanShow:false,//禁用按钮
        ruleForm: {
          username:'', //名称
          password: '',//密码
          password2: '',//密码2
          mobile: '',//手机号
          sms_code:'',//手机验证码
          allow :'',//同意协议
          wode:true,
          num:0//拉条验证
          // sidentify:''
        },
        rules: {
          username: [
            { validator: userName, trigger: 'blur' }
          ],
          mobile: [
            { validator: checkAge, trigger: 'blur' }
          ],
          sms_code: [
            { validator: Verification, trigger: 'blur' }
          ],
          // password: [
          //   { validator: validatePass, trigger: 'blur' }
          // ],
          allow : [
             {required: true, message: '你没有勾选协议', trigger: 'blur' }
          ]
        }
      };
    },
    created() {
      // 给win添加事件
 window.addEventListener('resize', this.handleResize);
 this.handleResizeing()
    },
    mounted(){
        },
computed: {
    count () {
      return this.$store.state.RegisterModule.count
    },
},
    methods: {
// 失去手机号框焦点
handch() {
  // if(this.ruleForm.mobile)
  // console.log(e)
  // console.log(this.count)
  const data = this.ruleForm.mobile
  // 测试手机号是否被注册
  this.$store.dispatch("getmobile",data).then((res) => {
    // console.log(res.data.count)
    if(res.data.count == 1 ) {
      this.$message({
                showClose: true,
                message: '你曾经使用这个手机号注册过,继续操作会将手机号和微信绑定一起',
                type: 'warning'
      })
      this.yanShow =true
      // this.yanShow =false
      // this.ruleForm.mobile = ''
    }else {
      this.$message({
                showClose: true,
                message: '你正在绑定这个手机号',
                type: 'warning'
      })
      this.yanShow =true
    }
  })

},
// 昵称失去焦点
// nameFn(e) {
// this.ruleForm.username
// console.log(e)
// },
// 密码输入框失去焦点
passwordFu(e) {
  // console.log(e)
  // var reg=/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/;
  var reg=/^[^]{8,16}$/;
if(e != '' && reg.test(e)) {
// console.log('正确')
}else {
// this.open()
this.$message({
   showClose: true,
  message: '密码填写错误',
  type: 'warning'
});
this.ruleForm.password = ''
// console.log('密码错误')
}
},
// 密码再次输入
passwordFu2(e){
// console.log(e)
if(e === this.ruleForm.password) {
// console.log("正确")
}else {
this.$message({
   showClose: true,
  message: '两次密码不一致',
  type: 'warning'
});
this.ruleForm.password = ''
this.ruleForm.password2 = ''
}
},
// 适配
handleResize(e) {
            this.WidthSize = e.currentTarget.innerWidth
           // console.log(e.currentTarget.innerWidth)
          },
handleResizeing() {
      this.WidthSize = window.outerWidth
  },
          // 提交表单
      submitForm(formName) {
        // const that = this
        this.$refs[formName].validate((valid) => {
          if (valid) {

            const data = this.ruleForm
            // console.log(data.password)
            // console.log(data.password2)
            if(data.password === data.password2) {
              // console.log(this.$md5("hello"))
              let data =  {
                password: this.ruleForm.password,
                mobile: this.ruleForm.mobile,
                sms_code:this.ruleForm.sms_code,
                username:  this.ruleForm.username,
                access_token: sessionStorage.getItem('access')
              };
              // 提交表单,完成异步操作
              this.$store.dispatch("postWxLogin", data).then((res) => {

                // this.$message.error('有必要信息没有填写');
                // console.log(res)
                if(res.data.code == 0) {
                this.$message({
                          message: '恭喜你，你绑定成功了',
                          type: 'success'
                });
                localStorage.setItem('img',res.data.context.HeadImgurl);
                localStorage.setItem('name',res.data.context.NickName);
                this.$cookie.set('token',res.data.context.token)
                this.$router.push('/');
                  setInterval(() => {

                    window.location.reload()
                  },2000)
                  console.log("注册成功")
                } else {
                  alert("注册失败")
                }
              })
            }else {
              alert("两次密码错误")
            }

          } else {
            this.$message.error('有必要信息没有填写');
            return false;
          }
        });
      },
      // 点击验证码按钮，
      validateBtn(){
         //倒计时
         let time = 60;
         let timer = setInterval(() => {
         if(time == 0) {
          clearInterval(timer);
          this.disabled = false;
          this.btnTitle = "获取验证码";
         } else {
          this.btnTitle =time + '秒后重试';
          this.disabled = true;
          time--
         }
        },1000)
      },
      resetForm(formName) {
        this.$message('信息重置完毕');
        this.$refs[formName].resetFields();
      },
      // 获取验证码
      Verifi () {
        const num = this.ruleForm.num
        const mobile = this.ruleForm.mobile
        // console.log(mobile)
        // 判断手机号不能为空
        if(mobile == '') {
          this.$message({
                    showClose: true,
                    message: '手机号没有填写',
                    type: 'warning'
                  });
          // return false
        }else {
          // console.log()
          if(num == 100) {
            this.show = !this.show;
            this.validateBtn()
            let data ={
              mobile:mobile,
              num:num,
              code:'register'
            }
            // 发送填写的手机信息,发送请求
            this.$store.dispatch("verificationmobile", data).then((res) => {
              // console.log(res)
                this.$message({
                          showClose: true,
                          message: res.data.errmsg,
                          type: 'warning'
                        })
})
          }else {
            this.$message({
                      showClose: true,
                      message: '将验证拉至到100',
                      type: 'warning'
                    });
          }

        }


      }
    }
  }
</script>

<style scoped lang="scss">
.register {
width: 100%;
height: 80vh;
background-color: #fff;
.from {
  // height: 500px;
  margin-top: 0.4rem;
  background-color: #f5f8fa;
  border: 1px solid #e4ecf3;
border-radius: 15px;
margin-bottom: 0.4rem;
  span {
    text-align: center;
    display: block;
    width: 100%;
    height: 30px;
    padding: 20px;
    font-size: 20px;
  }
}
}
</style>
